// 获取场馆和停车场人流/车流量，后端放在activity-api服务里了
import { get } from '@/base/http-base.js'

export function getFlowSituation() {
  return get('/activity-api/api/v1/open/flow/situation')
}
